"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTargetOrigin = getTargetOrigin;
exports.sendMessage = sendMessage;
exports.setId = setId;
exports.setTargetOrigin = setTargetOrigin;
exports.setTheirNonce = setTheirNonce;
var _coreLog = _interopRequireDefault(require("../core-log"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Send messages across the IFRAME boundary to another instance ofo this component.
 *
 * @module core-messaging-send
 */

// their nonce, they send this to me and then I include this in all messages sent to them
var theirNonce = null;

// they give me an ID
var id = null;

// this is set by the conversation starter during initialization
// this is set by the conversation responder after the first received message
var iframeTargetOrigin = null;

/**
 * Sets the ID
 *
 * @param {string} newId The ID given to us
 */
function setId(newId) {
  id = newId;
}

/**
 * Sets the nonce give to us by our client.
 *
 * @param {*} nonce The new nonce
 */
function setTheirNonce(nonce) {
  theirNonce = nonce;
}

/**
 * Sets the target origin
 *
 * @param {*} origin The new target origin
 */
function setTargetOrigin(origin) {
  iframeTargetOrigin = origin;
}

/**
 * Gets the target origin
 *
 * @return {*} The target origin
 */
function getTargetOrigin() {
  return iframeTargetOrigin;
}

/**
 * Sends a message to a remote destination using the window.postMessage API.
 *
 * Typical usage is to just provide an action and data object. For more complex communication
 * including iframe to iframe communications, various overrides may be specified.
 *
 * @param {object} opts The options
 * @param {string} action The action of this message
 * @param {object} data The data to send in the message
 * @param {object} [destination] optional message destination, defaults to window.parent
 * @param {object} [overrideNonce] optional their nonce to be validated by the receiver
 * @param {object} [overrideID] optional destination id
 * @param {object} [overrideTargetOrigin] optional target origin
 */
function sendMessage(opts) {
  var action = opts.action,
    _opts$data = opts.data,
    data = _opts$data === void 0 ? {} : _opts$data,
    overrideNonce = opts.overrideNonce,
    overrideID = opts.overrideID,
    overrideTargetOrigin = opts.overrideTargetOrigin;
  var destination = opts.destination;
  var payload = {
    'action': action,
    'data': data,
    'nonce': overrideNonce ? overrideNonce : theirNonce,
    'id': overrideID ? overrideID : id
  };

  // default destination is window.parent
  if (!destination) {
    destination = window.parent;
  }
  var message = payload;
  if (!data.blob) {
    message = JSON.stringify(payload);
  }
  var targetOrigin = overrideTargetOrigin ? overrideTargetOrigin : iframeTargetOrigin;
  if (destination && targetOrigin) {
    try {
      destination.postMessage(message, targetOrigin);
    } catch (e) {
      _coreLog["default"].log('Error: Error sending IFRAME postMessage:' + e);
    }
  } else {
    _coreLog["default"].log('Error: Unable to send IFRAME postMessage, missing destination or target origin.');
  }
}
//# sourceMappingURL=send.js.map